export class AchToken {
	accountName: string = '';
	aba: string = '';
	accountNumber: string = '';
	accountType: string = '';
	addressLine1: string = '';
	zipCode: string = '';
	checkInfoKey: string = '';
}
